import * as React from 'react'

const HailIcon = props => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7808 6.65211C16.7889 7.02822 16.6768 7.40432 16.4688 7.71641C16.1487 8.20455 15.5885 8.54864 14.9243 8.54864H2.68892C1.96072 8.54864 1.28853 8.12453 1.00045 7.45234C0.89642 7.20427 0.832403 6.93219 0.800394 6.66012C0.784389 6.49207 0.776387 6.31602 0.784389 6.13997C0.848407 4.71557 1.76066 3.29118 3.13704 3.48323C3.13704 3.48323 3.13705 3.48323 3.14505 3.48323C3.12904 3.27517 3.12904 3.07512 3.15305 2.88306C3.48114 0.218321 7.60229 -1.36612 9.4188 1.61871C9.56284 1.85878 9.69887 2.13085 9.81091 2.42694C11.6434 0.666445 14.8363 2.48295 14.2361 4.89963C13.836 6.50807 13.836 6.50807 14.2361 4.89963C15.3084 4.74758 16.0366 5.10768 16.4448 5.65984C16.6608 5.96392 16.7728 6.31602 16.7808 6.65211Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.53083 3.15439C9.50682 3.47448 9.4188 3.84258 9.13072 3.97862C8.88265 4.09865 8.57856 3.98662 8.3465 3.83458C8.11443 3.68254 7.90638 3.48248 7.6343 3.40246C7.10615 3.24242 6.57 3.59451 6.16989 3.97062C5.76978 4.34672 5.36167 4.78685 4.81751 4.86687C4.32938 4.93889 3.83324 4.67481 3.52916 4.29071C3.3451 4.05064 3.21707 3.77857 3.13705 3.48248C3.13705 3.48248 3.13705 3.48248 3.14505 3.48248C2.86497 0.465642 7.46625 -1.58293 9.4188 1.60996C9.52283 2.1141 9.56284 2.63425 9.53083 3.15439Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.81678 5.29949C4.5287 5.56356 4.04856 5.42752 3.69646 5.59557C3.23233 5.81963 3.16832 6.46781 2.80021 6.83591C2.41611 7.22002 1.74392 7.20402 1.3038 6.87593L1.29579 6.86792C0.903686 6.57184 0.743641 6.0677 0.839668 5.58757C1.07973 4.37123 1.93597 3.30693 3.12831 3.48298C3.12831 3.48298 3.12831 3.48298 3.13631 3.48298C3.1203 3.27492 3.1203 3.07487 3.14431 2.88281C3.85651 3.01085 4.51269 3.47498 4.83278 4.13116C4.92081 4.30721 4.98482 4.49926 5.00083 4.69932C5.02483 4.91538 4.97682 5.14744 4.81678 5.29949Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.0735 0.657026C6.99348 0.512986 6.84144 0.416959 6.67339 0.416959C6.25728 0.408957 5.84116 0.448967 5.48106 0.649023C5.36903 0.713041 5.265 0.793064 5.22499 0.913097C5.20899 0.969113 5.20898 1.02513 5.20898 1.08114C5.21699 1.20118 5.24099 1.32921 5.32102 1.41724C5.40104 1.50526 5.52107 1.53727 5.6331 1.53727C5.74513 1.52927 5.85717 1.48126 5.95319 1.41724C6.02521 1.36922 6.08923 1.30521 6.15325 1.25719C6.28128 1.16117 6.43333 1.10515 6.58537 1.07314C6.7054 1.04914 6.84144 1.04113 6.94547 0.977115C7.0655 0.913097 7.13752 0.761055 7.0735 0.657026Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.71291 1.58594C4.64089 1.58594 4.56887 1.60194 4.51286 1.64996C4.40083 1.74598 4.3048 1.86602 4.24878 2.01006C4.21677 2.09008 4.19277 2.18611 4.20077 2.27413C4.21677 2.36215 4.26479 2.45018 4.34481 2.49019C4.40883 2.5222 4.48085 2.5222 4.54487 2.50619C4.76893 2.46618 4.97699 2.29814 5.05701 2.08208C5.08902 1.99405 5.10502 1.89802 5.08102 1.81C5.04901 1.68196 4.93698 1.59394 4.80094 1.59394L4.71291 1.58594Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.68141 3.94654C2.34532 3.99455 2.04123 4.1706 1.83318 4.43467C1.65713 4.66674 1.52909 4.94681 1.48908 5.23489C1.47308 5.32292 1.47308 5.42695 1.5451 5.48296C1.58511 5.51497 1.64112 5.52298 1.68914 5.53098C1.77716 5.53898 1.86519 5.53898 1.93721 5.50697C2.06524 5.44295 2.11326 5.29891 2.16127 5.17088C2.2653 4.9068 2.43334 4.62673 2.70542 4.5387C2.72143 4.5307 2.73743 4.5307 2.75343 4.5227C2.84946 4.49869 2.93749 4.43467 2.9775 4.33865C3.10553 4.10658 2.88147 3.90652 2.68141 3.94654Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2116 2.59499C10.1396 2.651 10.0756 2.71502 10.0356 2.79504C9.99555 2.86706 9.98754 2.95509 10.0116 3.03511C10.0756 3.22716 10.2996 3.22716 10.4517 3.14714C10.5797 3.08312 10.6757 2.97109 10.7878 2.87507C10.9718 2.73103 11.1959 2.65901 11.4199 2.59499C11.492 2.57898 11.564 2.55498 11.628 2.50696C11.684 2.45895 11.724 2.37893 11.692 2.30691C11.66 2.23489 11.572 2.21088 11.492 2.20288C11.2359 2.17887 10.9718 2.21088 10.7398 2.31491L10.6277 2.36292C10.4757 2.43494 10.3396 2.50696 10.2116 2.59499Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3723 5.62639C14.5483 5.61038 14.7244 5.61038 14.8924 5.63439C15.1965 5.6664 15.4926 5.77843 15.6927 6.0105C16.2208 6.62667 15.8127 7.54692 15.1005 7.76298C14.8044 7.85101 14.4843 7.85901 14.1722 7.84301C13.7561 7.827 13.332 7.77099 12.9799 7.54692C12.5078 7.24284 12.3477 6.52264 12.7879 6.11452C12.9559 5.95448 13.18 5.87446 13.404 5.81044C13.7081 5.72242 14.0442 5.6584 14.3723 5.62639Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0983 6.5949C10.9383 6.67493 10.7862 6.78696 10.7142 6.89899C10.6422 7.00302 10.6662 7.12305 10.7062 7.22708C10.7382 7.3071 10.7702 7.38713 10.8342 7.44314C11.0183 7.61919 11.4424 7.61119 11.6424 7.48315C11.8185 7.37912 11.9545 7.11505 11.9225 6.90699C11.8985 6.77095 11.7785 6.61891 11.6665 6.54689C11.5144 6.45887 11.2984 6.49888 11.0983 6.5949Z"
      fill="#CBBEBB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.55472 11.5731C5.52271 11.6452 5.4827 11.7092 5.44269 11.7652C5.05058 12.3894 4.47442 12.5174 3.98629 12.2693C3.6662 12.1093 3.44213 11.8292 3.41013 11.4531C3.38612 11.205 3.43413 10.917 3.59418 10.5969C3.83424 10.1087 4.41841 9.86866 4.82652 9.74863C5.0986 9.66861 5.37867 9.81265 5.4827 10.0767C5.64275 10.4768 5.79479 11.085 5.55472 11.5731Z"
      fill="#B2B2B2"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.25747 11.6845C5.3695 11.7005 5.40951 11.8365 5.33749 11.9166C4.95338 12.4047 4.43324 12.4927 3.98512 12.2687C3.69703 12.1246 3.49698 11.8845 3.42496 11.5805C3.40895 11.5084 3.45697 11.4284 3.52899 11.4124C3.86508 11.3244 4.12115 11.6765 4.43324 11.7885C4.74533 11.8925 4.96139 11.6365 5.25747 11.6845Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.31361 10.252C4.2736 10.252 4.23359 10.26 4.19358 10.284C4.06554 10.348 3.93751 10.476 3.9055 10.6201C3.86549 10.7721 4.00153 10.9561 4.16157 10.8521C4.28961 10.7641 4.49766 10.596 4.49766 10.42C4.48966 10.3 4.40964 10.252 4.31361 10.252Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.96143 11.7654C3.94543 11.7254 3.91342 11.6853 3.88141 11.6533C3.87341 11.6453 3.86541 11.6453 3.86541 11.6373C3.81739 11.6053 3.76138 11.5973 3.72137 11.6453C3.68136 11.6934 3.68936 11.7574 3.71336 11.8134C3.73737 11.8454 3.76138 11.8774 3.80139 11.9014C3.80939 11.9094 3.81739 11.9174 3.8334 11.9174C3.8494 11.9254 3.86541 11.9254 3.87341 11.9174C3.91342 11.9174 3.96143 11.9014 3.97744 11.8694C3.99344 11.8374 3.98544 11.8054 3.96944 11.7734C3.96143 11.7734 3.96143 11.7654 3.96143 11.7654Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.17654 11.8532C4.20855 11.8452 4.24856 11.8532 4.28057 11.8532C4.30457 11.8532 4.32058 11.8612 4.33658 11.8692C4.35259 11.8852 4.36059 11.9092 4.36059 11.9412C4.36059 11.9732 4.34459 11.9972 4.31258 12.0052C4.26456 12.0212 4.19254 12.0372 4.15253 11.9972C4.11252 11.9572 4.11252 11.8692 4.17654 11.8532Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5879 11.5731C13.5559 11.6452 13.5159 11.7092 13.4759 11.7652C13.0838 12.3894 12.5076 12.5174 12.0195 12.2693C11.6994 12.1093 11.4753 11.8292 11.4433 11.4531C11.4193 11.205 11.4673 10.917 11.6274 10.5969C11.8674 10.1087 12.4516 9.86866 12.8677 9.74863C13.1398 9.66861 13.4199 9.81265 13.5239 10.0767C13.6679 10.4768 13.828 11.085 13.5879 11.5731Z"
      fill="#B2B2B2"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2926 11.6845C13.4047 11.7005 13.4447 11.8365 13.3726 11.9166C12.9885 12.4047 12.4684 12.4927 12.0203 12.2687C11.7322 12.1246 11.5321 11.8845 11.4601 11.5805C11.4441 11.5084 11.4921 11.4284 11.5641 11.4124C11.9002 11.3244 12.1563 11.6765 12.4684 11.7885C12.7725 11.8925 12.9965 11.6365 13.2926 11.6845Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3468 10.252C12.3068 10.252 12.2668 10.26 12.2268 10.284C12.0987 10.348 11.9707 10.476 11.9387 10.6201C11.8987 10.7721 12.0347 10.9561 12.1948 10.8521C12.3228 10.7641 12.5309 10.596 12.5309 10.42C12.5229 10.3 12.4348 10.252 12.3468 10.252Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.987 11.7654C11.971 11.7254 11.939 11.6853 11.907 11.6533C11.899 11.6453 11.891 11.6453 11.891 11.6373C11.843 11.6053 11.787 11.5973 11.7389 11.6453C11.6989 11.6934 11.7069 11.7574 11.7309 11.8134C11.7549 11.8454 11.779 11.8774 11.819 11.9014C11.827 11.9094 11.835 11.9174 11.851 11.9174C11.867 11.9254 11.883 11.9254 11.891 11.9174C11.931 11.9174 11.979 11.9014 11.995 11.8694C12.011 11.8374 12.003 11.8054 11.987 11.7734C11.995 11.7734 11.987 11.7654 11.987 11.7654Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2123 11.8532C12.2443 11.8452 12.2844 11.8532 12.3244 11.8532C12.3484 11.8532 12.3644 11.8612 12.3804 11.8692C12.3964 11.8852 12.4044 11.9092 12.4044 11.9412C12.4044 11.9732 12.3884 11.9972 12.3564 12.0052C12.3084 12.0212 12.2363 12.0372 12.1963 11.9972C12.1483 11.9572 12.1483 11.8692 12.2123 11.8532Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.29914 14.1664C9.26713 14.2305 9.22712 14.2945 9.19511 14.3505C8.81101 14.9507 8.25885 15.0707 7.78672 14.8386C7.47463 14.6866 7.26658 14.4065 7.22656 14.0544C7.20256 13.8143 7.25057 13.5343 7.40261 13.2222C7.63468 12.758 8.19483 12.518 8.59495 12.4059C8.85102 12.3339 9.1311 12.47 9.22712 12.718C9.37916 13.1101 9.53121 13.7023 9.29914 14.1664Z"
      fill="#B2B2B2"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00247 14.2765C9.10649 14.2925 9.14651 14.4205 9.08249 14.5005C8.70638 14.9727 8.21024 15.0527 7.77812 14.8366C7.49805 14.7006 7.30599 14.4685 7.23397 14.1724C7.21797 14.1004 7.25798 14.0284 7.33 14.0044C7.65809 13.9244 7.89816 14.2605 8.20224 14.3645C8.50633 14.4765 8.72239 14.2284 9.00247 14.2765Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.09848 12.8926C8.05847 12.8926 8.01846 12.9006 7.98645 12.9166C7.85842 12.9806 7.73838 13.1006 7.70638 13.2447C7.67437 13.3967 7.7944 13.5728 7.94644 13.4687C8.07448 13.3807 8.27453 13.2207 8.26653 13.0526C8.26653 12.9406 8.18651 12.8926 8.09848 12.8926Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.7544 14.3492C7.7384 14.3092 7.70639 14.2691 7.67438 14.2451C7.66638 14.2451 7.66638 14.2371 7.65838 14.2291C7.61036 14.1971 7.55435 14.1891 7.51434 14.2371C7.47432 14.2851 7.48233 14.3492 7.50633 14.3972C7.52234 14.4292 7.55435 14.4612 7.58636 14.4772C7.59436 14.4852 7.60236 14.4852 7.61836 14.4932C7.63437 14.5012 7.64237 14.5012 7.65838 14.5012C7.69839 14.5012 7.7384 14.4852 7.76241 14.4532C7.77841 14.4292 7.77041 14.3892 7.7544 14.3652C7.7544 14.3572 7.7544 14.3572 7.7544 14.3492Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.97146 14.4372C8.00347 14.4291 8.04348 14.4372 8.07549 14.4372C8.09149 14.4372 8.1155 14.4452 8.1315 14.4532C8.14751 14.4692 8.15551 14.4932 8.15551 14.5172C8.15551 14.5492 8.13951 14.5732 8.1075 14.5812C8.05949 14.5972 7.99547 14.6132 7.94745 14.5732C7.90744 14.5412 7.90744 14.4532 7.97146 14.4372Z"
      fill="white"
    />
  </svg>
)

export default HailIcon
